export default __webpack_public_path__ + "images/ntt-com-logo.svg";